export const cacheBaseKeys = {
  user: 'User',
  settingsLanguages: 'SettingsLanguages',
  settingsSubscriptions: 'SettingsSubscriptions',
  settingsPayments: 'SettingsPayments',
  settingsPaymentDetails: 'SettingsPaymentDetails',
  adminUsers: 'AdminUsers',
  adminUserRoles: 'AdminUserRoles',
} as const;
